export const tickerItems = [
  'v9.1.12 正式版已上线，安装包体积再降 18%',
  '新增智能省流模式，弱网环境下载更稳',
  '安卓 7.0+ / iOS 13.0+ 全平台适配',
  '安装向导升级，一键完成权限配置',
  '官方渠道校验签名，无捆绑无静默安装',
];

export const downloadOptions = [
  {
    key: 'android',
    platform: '安卓 Android',
    icon: 'ri-android-line',
    version: 'v9.1.12',
    size: '28.6 MB',
    updated: '2026-09-28',
    fit: '适配安卓 7.0 及以上',
    detail: 'APK 直装包，签名校验通过',
    tag: '推荐',
  },
  {
    key: 'ios',
    platform: 'iOS / iPadOS',
    icon: 'ri-apple-line',
    version: 'v9.1.12',
    size: '41.2 MB',
    updated: '2026-09-28',
    fit: '适配 iOS 13.0 及以上',
    detail: '描述文件安装，支持 TestFlight',
    tag: '稳定',
  },
  {
    key: 'desktop',
    platform: '电脑 / 网页版',
    icon: 'ri-computer-line',
    version: '在线版',
    size: '免安装',
    updated: '实时同步',
    fit: 'Win / macOS / 浏览器',
    detail: '扫码后与手机端数据互通',
    tag: '便捷',
  },
];

export const heroStats = [
  { label: '累计下载量', value: '2,860 万+' },
  { label: '安装成功率', value: '99.2%' },
  { label: '平均安装耗时', value: '约 45 秒' },
  { label: '用户好评率', value: '4.8 / 5' },
];

export const installSteps = [
  {
    no: '01',
    title: '核对设备与系统版本',
    summary: '先确认手机系统是否满足最低要求，安卓需 7.0 以上、iOS 需 13.0 以上，避免装到一半被系统拦截。',
  },
  {
    no: '02',
    title: '获取对应平台的安装包',
    summary: '安卓用户下载 APK 直装包，iOS 用户下载描述文件，电脑端可直接使用网页版，三者账号数据通用。',
  },
  {
    no: '03',
    title: '按提示完成安装授权',
    summary: '安卓若提示「未知来源」，在设置中允许本次安装即可；iOS 需在描述文件中点击信任后再返回桌面。',
  },
  {
    no: '04',
    title: '登录并完成首次配置',
    summary: '首次打开按向导选择省流策略、下载目录与通知偏好，约 1 分钟即可进入主界面开始使用。',
  },
];

export const features = [
  {
    icon: 'ri-flashlight-line',
    title: '极速下载引擎',
    summary: '多线程分段与断点续传结合，弱网环境下依然保持稳定速度，大文件也能一口气下完。',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20speed%20and%20data%20flow%20visualization%20with%20warm%20amber%20and%20cream%20geometric%20shapes%2C%20motion%20lines%20suggesting%20fast%20download%20transfer%2C%20minimal%20flat%20illustration%20style%2C%20soft%20paper%20texture%20background%2C%20editorial%20tech%20poster%2C%20high%20detail%2C%20harmonious%20warm%20composition&width=800&height=600&seq=feat-engine-91&orientation=landscape',
  },
  {
    icon: 'ri-wifi-off-line',
    title: '智能省流模式',
    summary: '按网络环境自动切换清晰度与缓存策略，移动数据下优先压缩，流量消耗一目了然。',
    image:
      'https://readdy.ai/api/search-image?query=Minimal%20illustration%20of%20network%20signal%20and%20data%20saving%20concept%20with%20teal%20and%20cream%20color%20blocks%2C%20abstract%20signal%20bars%20and%20leaf%20motif%2C%20flat%20vector%20style%2C%20clean%20warm%20paper%20background%2C%20soft%20shadows%2C%20editorial%20tech%20graphic%2C%20high%20detail%2C%20balanced%20composition&width=800&height=600&seq=feat-data-91&orientation=landscape',
  },
  {
    icon: 'ri-shield-check-line',
    title: '清爽无广告干扰',
    summary: '安装向导与应用界面均保持简洁，无捆绑推荐、无弹窗诱导，每一步操作都清晰可控。',
    image:
      'https://readdy.ai/api/search-image?query=Clean%20modern%20app%20interface%20mockup%20on%20cream%20and%20amber%20background%2C%20minimal%20cards%20and%20toggle%20controls%2C%20flat%20ui%20design%20presentation%2C%20soft%20studio%20lighting%2C%20uncluttered%20layout%2C%20editorial%20product%20shot%2C%20high%20detail%2C%20harmonious%20tone&width=800&height=600&seq=feat-clean-91&orientation=landscape',
  },
  {
    icon: 'ri-device-line',
    title: '多端同步与备份',
    summary: '手机与电脑数据实时互通，下载记录、收藏与偏好设置云端备份，换设备也不丢失。',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20multi%20device%20sync%20illustration%20showing%20smartphone%20laptop%20and%20tablet%20connected%20by%20flowing%20lines%2C%20warm%20amber%20and%20teal%20accents%20on%20cream%20background%2C%20flat%20vector%20style%2C%20soft%20shapes%2C%20editorial%20tech%20graphic%2C%20high%20detail%2C%20balanced%20composition&width=800&height=600&seq=feat-sync-91&orientation=landscape',
  },
];

export const rankingTabs = ['下载榜', '热度榜', '收藏榜'] as const;

export const rankingData: Record<
  string,
  { name: string; category: string; metric: string; heat: number; delta: string }[]
> = {
  下载榜: [
    { name: '91免费版 标准安装包', category: '官方通道', metric: '本周 428.6 万次', heat: 98, delta: '+12%' },
    { name: '高速下载组件', category: '加速插件', metric: '本周 271.3 万次', heat: 88, delta: '+9%' },
    { name: '省流优化补丁', category: '省流扩展', metric: '本周 194.7 万次', heat: 79, delta: '+6%' },
    { name: '安装向导工具', category: '辅助工具', metric: '本周 143.2 万次', heat: 68, delta: '+4%' },
    { name: '多端同步助手', category: '同步组件', metric: '本周 118.9 万次', heat: 61, delta: '+3%' },
    { name: '缓存清理模块', category: '维护工具', metric: '本周 96.4 万次', heat: 54, delta: '+2%' },
    { name: '签名校验器', category: '安全组件', metric: '本周 74.1 万次', heat: 46, delta: '+1%' },
    { name: '桌面快捷入口', category: '便捷组件', metric: '本周 58.3 万次', heat: 38, delta: '+1%' },
  ],
  热度榜: [
    { name: '91免费版 全新界面', category: '版本更新', metric: '热度指数 96.4', heat: 96, delta: '+18%' },
    { name: '一键安装体验', category: '安装引导', metric: '热度指数 89.1', heat: 89, delta: '+14%' },
    { name: '弱网省流方案', category: '网络优化', metric: '热度指数 82.7', heat: 82, delta: '+11%' },
    { name: '跨设备同步', category: '云同步', metric: '热度指数 76.5', heat: 76, delta: '+8%' },
    { name: '免广告纯净模式', category: '体验优化', metric: '热度指数 70.2', heat: 70, delta: '+6%' },
    { name: '安装失败自助排查', category: '帮助中心', metric: '热度指数 63.8', heat: 63, delta: '+5%' },
    { name: '隐私权限说明', category: '安全合规', metric: '热度指数 57.4', heat: 57, delta: '+3%' },
    { name: '老机型适配', category: '兼容性', metric: '热度指数 49.6', heat: 49, delta: '+2%' },
  ],
  收藏榜: [
    { name: '省流模式速查卡', category: '使用技巧', metric: '被收藏 82.3 万', heat: 94, delta: '+10%' },
    { name: '安装图文指引', category: '安装教程', metric: '被收藏 76.9 万', heat: 87, delta: '+9%' },
    { name: '常见报错对照表', category: '问题排查', metric: '被收藏 68.5 万', heat: 80, delta: '+7%' },
    { name: '多端同步设置', category: '功能说明', metric: '被收藏 59.2 万', heat: 72, delta: '+5%' },
    { name: '存储清理清单', category: '维护指南', metric: '被收藏 51.7 万', heat: 64, delta: '+4%' },
    { name: '权限管理说明', category: '安全指引', metric: '被收藏 44.1 万', heat: 56, delta: '+3%' },
    { name: '版本更新日志', category: '更新记录', metric: '被收藏 38.6 万', heat: 48, delta: '+2%' },
    { name: '新手入门清单', category: '入门指引', metric: '被收藏 31.4 万', heat: 40, delta: '+1%' },
  ],
};

export const newsList = [
  {
    title: 'v9.1.12 更新日志：安装包瘦身与省流算法升级',
    summary: '本次更新将安装包压缩至 28.6 MB，同时重写省流算法，移动数据下下载流量平均下降两成。',
    date: '2026-09-28',
    tag: '版本更新',
  },
  {
    title: '安卓安装提示「未知来源」怎么办？三步解决',
    summary: '多数安装中断由系统权限拦截导致，按引导在设置中允许本次来源，完成安装后可随时收回权限。',
    date: '2026-09-24',
    tag: '安装教程',
  },
  {
    title: 'iOS 描述文件信任设置图文说明',
    summary: '下载描述文件后需要手动前往设置信任该来源，否则图标会显示为灰色无法打开，本文逐步演示。',
    date: '2026-09-19',
    tag: '安装教程',
  },
  {
    title: '弱网环境下如何让下载更快更稳',
    summary: '组合使用断点续传与省流模式，并在信号稳定时集中下载，可显著减少下载中断的概率。',
    date: '2026-09-15',
    tag: '使用技巧',
  },
  {
    title: '多端同步怎么用？手机与电脑数据打通指南',
    summary: '同一账号在电脑端网页版扫码即可绑定，下载记录与收藏自动同步，无需手动导入导出。',
    date: '2026-09-10',
    tag: '功能说明',
  },
  {
    title: '安装失败自查清单：五个常见原因',
    summary: '存储空间不足、系统版本过低、安装包损坏、权限未授权、重复安装，逐一排查即可定位问题。',
    date: '2026-09-05',
    tag: '问题排查',
  },
];

export const faqList = [
  {
    q: '91免费版下载后找不到安装包在哪？',
    a: '安卓设备一般在「文件管理 - 下载」目录，iOS 则保存在「文件 - 我的 iPhone - 下载」中。若不确定，可在浏览器下载记录里直接点击已下载文件打开安装。',
  },
  {
    q: '安装时提示「未知来源」或「无法验证」怎么处理？',
    a: '这是系统的安全提示。安卓在设置中允许本次安装来源即可；iOS 需要前往「设置 - 通用 - VPN 与设备管理」中信任对应描述文件，然后再回到桌面打开。',
  },
  {
    q: '91免费版支持哪些系统和机型？',
    a: '安卓需 7.0 及以上版本，iOS 需 13.0 及以上版本，电脑端支持主流浏览器直接使用网页版，老机型建议使用轻量模式。',
  },
  {
    q: '安装包体积多大，会占用很多存储吗？',
    a: '最新版安装包约 28.6 MB，安装完成后占用通常在 120 MB 以内，可在设置中清理缓存进一步释放空间。',
  },
  {
    q: '为什么下载速度不稳定或会中断？',
    a: '速度受网络环境影响较大。建议在信号稳定时下载，并开启断点续传，即使中途断开也可以从上次位置继续，不会从头重来。',
  },
  {
    q: '手机和电脑之间可以同步数据吗？',
    a: '可以。使用同一账号登录，电脑端扫码绑定后，下载记录、收藏与偏好设置会自动同步，无需手动传输。',
  },
];

export const navLinks = [
  { label: '下载入口', href: '#download' },
  { label: '安装步骤', href: '#install' },
  { label: '功能亮点', href: '#features' },
  { label: '热门榜单', href: '#ranking' },
  { label: '资讯速览', href: '#news' },
  { label: '常见问题', href: '#faq' },
];